import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../../_actions/matchesActions";
import getRecentlyViewed from "../../../_selectors/matchesSelectors/getRecentlyViewed";
import UserWidgetContainer from "../UserWidgetContainer";
import Section from "../../UI/Section";
import PageSubTitle from "../../UI/PageSubTitle";
import InfiniteScroll from "react-infinite-scroller";
import getSaved from "../../../_selectors/matchesSelectors/getSaved";
import { updateObject } from "../../../_utils";
import matchesConstants from "../../../_constants/matchesConstants";
import getMatchesLastResult from "../../../_selectors/matchesSelectors/getMatchesLastResult";
import HoverWidget from "../../UI/HoverWidget";
class Saved extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getSaved } = this.props;
    updateHeader({
      title: "Saved Members",
      description: "Members that you saved"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Matches", link: "/matches" },
      { label: "Saved Members", link: "/search" }
    ]);
    getSaved();
  }
  componentWillUnmount() {
    const { clearMembers, clearSaved } = this.props;
    clearMembers();
    clearSaved();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section white={results.length === 0}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you saved"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getSaved(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getSaved: () => dispatch(matchesActions.getSavedMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearSaved: () => dispatch(matchesActions.clearSavedMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_SAVED_MEMBERS })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Saved);



// WEBPACK FOOTER //
// ./src/_components/Matches/Saved/index.js